import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '管理员登录' }
  },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '工作台' } },
      { path: 'students', name: 'Students', component: () => import('../views/Students.vue'), meta: { title: '实习生管理' } },
      { path: 'teachers', name: 'Teachers', component: () => import('../views/Teachers.vue'), meta: { title: '带教老师管理' } },
      { path: 'departments', name: 'Departments', component: () => import('../views/Departments.vue'), meta: { title: '科室管理' } },
      { path: 'schools', name: 'Schools', component: () => import('../views/Schools.vue'), meta: { title: '院校管理' } },
      { path: 'batches', name: 'Batches', component: () => import('../views/Batches.vue'), meta: { title: '批次管理' } },
      { path: 'rotation', name: 'Rotation', component: () => import('../views/Rotation.vue'), meta: { title: '轮转计划' } },
      { path: 'question-bank', name: 'QuestionBank', component: () => import('../views/QuestionBank.vue'), meta: { title: '题库管理' } },
      { path: 'survey', name: 'Survey', component: () => import('../views/Survey.vue'), meta: { title: '问卷管理' } },
      { path: 'statistics', name: 'Statistics', component: () => import('../views/Statistics.vue'), meta: { title: '数据统计' } },
      { path: 'attendance-detail', name: 'AttendanceDetail', component: () => import('../views/AttendanceDetail.vue'), meta: { title: '考勤明细' } },
      { path: 'exam-detail', name: 'ExamDetail', component: () => import('../views/ExamDetail.vue'), meta: { title: '考核明细' } },
      { path: 'process-detail', name: 'ProcessDetail', component: () => import('../views/ProcessDetail.vue'), meta: { title: '流程明细' } },
      { path: 'evaluation-criteria', name: 'EvaluationCriteria', component: () => import('../views/EvaluationCriteria.vue'), meta: { title: '评价指标管理' } },
      { path: 'dept-evaluations', name: 'DeptEvaluations', component: () => import('../views/DeptEvaluations.vue'), meta: { title: '出科评价记录' } },
      { path: 'feedback-records', name: 'FeedbackRecords', component: () => import('../views/FeedbackRecords.vue'), meta: { title: '教学反馈记录' } },
      { path: 'internship-appraisal', name: 'InternshipAppraisal', component: () => import('../views/InternshipAppraisal.vue'), meta: { title: '实习鉴定' } },
      { path: 'shift-types', name: 'ShiftTypes', component: () => import('../views/ShiftTypes.vue'), meta: { title: '班次管理' } },
      { path: 'schedules', name: 'Schedules', component: () => import('../views/Schedules.vue'), meta: { title: '排班管理' } },
      { path: 'settings', name: 'Settings', component: () => import('../views/Settings.vue'), meta: { title: '系统配置' } },
      { path: 'logs', name: 'Logs', component: () => import('../views/Logs.vue'), meta: { title: '操作日志' } },
      { path: 'notifications', name: 'Notifications', component: () => import('../views/Notifications.vue'), meta: { title: '通知管理' } },
      { path: 'transfer-review', name: 'TransferReview', component: () => import('../views/TransferReview.vue'), meta: { title: '转科审核' } },
      { path: 'visual-dashboard', name: 'VisualDashboard', component: () => import('../views/VisualDashboard.vue'), meta: { title: '数据可视化大屏' } },
      { path: 'comment-templates', name: 'CommentTemplates', component: () => import('../views/CommentTemplates.vue'), meta: { title: '评语模板' } },
      { path: 'score-items', name: 'ScoreItems', component: () => import('../views/ScoreItems.vue'), meta: { title: '成绩项配置' } },
      { path: 'score-entry', name: 'ScoreEntry', component: () => import('../views/ScoreEntry.vue'), meta: { title: '成绩登记' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title + ' - 护理实习管理后台'
  if (to.path !== '/login' && !localStorage.getItem('admin_token')) {
    next('/login')
  } else {
    next()
  }
})

export default router
